var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "tag-basic-icon",
    style: _vm.styles,
    attrs: {
      "id": _vm.$attrs._id,
      "dir": _vm.language.dir
    }
  }, [_c('fa', {
    staticClass: "tag-basic-icon__icon",
    attrs: {
      "icon": ['fad', _vm.faIcon]
    }
  }), _c('div', {
    staticClass: "tag-basic-icon__label",
    domProps: {
      "innerHTML": _vm._s(_vm.label[_vm.language.code])
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }